import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Row, Col } from 'react-bootstrap';
import windowSize from 'react-window-size';
import _ from 'lodash';
import SearchForm from './SearchForm';
import LoadingProgressBar from './LoadingProgressBar';
import Button from './Button';
import Table from './Table';
import { clientsUpdateColumnsAction,
         clientsLoadAction } from '../../actions/clientActions';

import { caseSetServerError } from '../../actions/caseActions';
import { defaultClientType } from '../../helpers/config';
import { isEmptyString } from '../../validators/formValidators';
import { dialogHeaderFooterBgColor } from '../../helpers/colors';
import { findBootstrapEnvironment } from '../../helpers/utils';


export const searchClients = async(filterObj) => {
    try {
        const result = await clientsLoadAction(filterObj.query).promise;
        let clients = result.data.clients.filter(client => {
            return !client.client.ClientType || client.client.ClientType === defaultClientType;
        });

        clients = clients.map(option => {
            if (isEmptyString(option.client['ClientType'])) {
                option.client['ClientType'] = 'Client';
            }

            return option;
        });

        return { clients, headers: result.data.headers };
    } catch (error) {
        console.error(new Error().stack, error);
        return { error };
    }
};

class LoadClientDialog extends PureComponent {
    constructor(props) {
        super(props);
        this.onColumnResized = this.onColumnResized.bind(this);
        this.search = this.search.bind(this);
        this.state = {
            rows: [],
            headers: [],
            loading: false,
        };
    }

    async search(filterObj) {
        this.setState({loading: true});
        const result = await searchClients(filterObj);
        if (result.error) {
            this.props.dispatch(caseSetServerError(result.error));
            return;
        }

        this.setState({
            loading: false,
            rows: result.clients,
            headers: result.headers
        });
    }

    onColumnResized(newHeaders) {
        this.props.dispatch(clientsUpdateColumnsAction(newHeaders))
            .catch((error) => {
                console.error(new Error().stack, error);
                this.props.dispatch(caseSetServerError(error));
            });
    }

    componentDidMount() {
        if (!this.props.data) {
            this.search({query:'', filter: undefined});
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data) {
            this.setState({
                rows: nextProps.data.rows,
                headers: nextProps.data.headers
            });
        }
    }

    render() {
        const {
            showSearchForm = true,
            title = 'New Case For Existing Client',
            action = ''
        } = this.props;

        let headers = this.props.headers;
        if (_.isEmpty(headers)) {
            headers = this.state.headers;
        }

        const size = findBootstrapEnvironment();
        let height = this.props.windowHeight;
        if (size !== 'xs') {
            height *= 0.60;
        } else {
            height *= 0.70;
        }

        return (
            <Modal show={this.props.open}
                   onHide={this.props.cancel}
                   dialogClassName="modal-dialog-full"
                   backdrop='static'
            >
                <Modal.Header closeButton style={{ backgroundColor: dialogHeaderFooterBgColor }}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showSearchForm &&
                    <Row>
                        <Col xs={12} style={{ marginLeft: 15, width: '85%' }}>
                            <SearchForm {...this.props}
                                        customSearch={this.search}
                                        hideAdvancedSearch
                                        recordType="client"
                                        hideNewRecord
                            />
                        </Col>
                    </Row>}
                    <Row>
                        <Col xs={12}>
                            <LoadingProgressBar loading={this.state.loading} />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} style={{height: height}}>
                            <Table
                                headers={headers}
                                rows={this.state.rows}
                                onColumnResized={this.onColumnResized}
                                selectRow={this.props.selectRow}
                                selectLabel="Select"
                                selectBsStyle="primary"
                                filterable={false}
                                buttonsWidth={110}/>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer style={{backgroundColor: dialogHeaderFooterBgColor }}>
                {action}
                </Modal.Footer>
            </Modal>
        );
    }
}

LoadClientDialog.propTypes = {
    cancel: PropTypes.func,
    open: PropTypes.bool.isRequired,
    selectRow: PropTypes.func.isRequired,
    showSearchForm: PropTypes.bool,
    data: PropTypes.object,
    title: PropTypes.string,
    action: PropTypes.string,
};

const mapStateToProps = (state) => {
    let headers = [];
    if (state.user.config) {
        headers = [...state.user.config.clientHeaders];
    }

    return {
        headers,
    }
}

export default connect(mapStateToProps)(windowSize(LoadClientDialog));
